import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-video-youtube.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import YTPlayer from 'yt-player';

export interface OutlineVideoYoutubeInterface extends HTMLElement {
  videoID: string;
}

/**
 * The Outline VideoYoutube component
 *
 * @element outline-video-youtube
 */
@customElement('outline-video-youtube')
export class OutlineVideoYoutube
  extends OutlineElement
  implements OutlineVideoYoutubeInterface
{
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true, attribute: 'id-rand' })
  idRand = `player-${Math.floor(Math.random() * 10000).toString()}`;

  @property({ type: String, attribute: 'video-id' })
  videoID: string;

  firstUpdated() {
    const id = this.idRand;
    const vid = this.videoID;
    const player = document.querySelector('#' + id) as HTMLElement;
    const ytPlayer = new YTPlayer(player);
    ytPlayer.load(vid);
  }

  render(): TemplateResult {
    return html` <div id="${this.idRand}"></div> `;
  }

  createRenderRoot() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-video-youtube': OutlineVideoYoutube;
  }
}
